<template>
  <div class="studio-product-lessons">
    <div class="row" v-if="product.lessons.length > 0">
      <div
        class="d-none d-md-block col-md-4 col-lg-3 lessons-list"
        ref="lessonsList"
      >
        <StudioLessonCard
          class="mb-2"
          :id="`lesson-${lesson.id}`"
          v-for="(lesson, index) in product.lessons"
          :key="lesson.id"
          :lesson="lesson"
          :index="index + 1"
          :total="product.lessons.length"
          :isSelected="selectedLesson == lesson"
          :hasAccess="canViewProductContent"
          @click="lessonSelected(lesson)"
        />
      </div>
      <div class="d-block d-md-none col-sm-12">
        <div
          v-for="(lesson, index) in product.lessons"
          :key="lesson.id"
          class="position-relative"
        >
          <span
            :id="`mobile-lesson-${lesson.id}`"
            class="mobile-lesson-mark"
          ></span>
          <StudioLessonCard
            class="mb-2"
            :lesson="lesson"
            :index="index + 1"
            :total="product.lessons.length"
            :isSelected="selectedLesson == lesson"
            :hasAccess="canViewProductContent"
            @click="lessonSelected(lesson)"
          >
            <template class="d-block d-md-none">
              <b-collapse
                :id="`collapse-content-${lesson.id}`"
                :visible="lesson === selectedLesson"
              >
                <hr />
                <StudioLessonContent
                  class="d-block d-md-none mt-4"
                  :product="product"
                  :lesson="selectedLesson"
                  :studioURL="studioURL"
                  :hasAccess="canViewProductContent"
                  :hasPurchased="product.purchased"
                  @click.stop
                />
              </b-collapse>
            </template>
          </StudioLessonCard>
        </div>
      </div>
      <div class="d-none d-md-block col-md-8 col-lg-9">
        <StudioLessonContent
          :class="{ review: review }"
          :product="product"
          :lesson="selectedLesson"
          :studioURL="studioURL"
          :hasAccess="canViewProductContent"
          :hasPurchased="product.purchased"
        />
      </div>
    </div>
    <div class="row" v-else-if="product.lessons.length == 0">
      <div class="col-12 text-center py-5">
        {{ $t('PRODUCTS.TEXT.NO_LESSONS_FOUND') }}
      </div>
    </div>
    <div class="page-bottom-filler"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import StudioLessonCard from '@/web/components/products/StudioLessonCard';
import StudioLessonContent from '@/web/components/products/StudioLessonContent';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioProductLessons',
  components: {
    StudioLessonCard,
    StudioLessonContent,
  },
  props: {
    review: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
      canViewProductContent: 'product/canViewProductContent',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  data() {
    return {
      selectedLesson: null,
    };
  },
  methods: {
    lessonSelected(lesson) {
      this.selectedLesson = lesson;
    },
  },
  watch: {
    product: {
      handler(product) {
        if (product?.lessons?.length > 0) {
          const nextLesson = Math.max(
            product.lessons.findIndex(
              lesson => !lesson.completed && !lesson.locked
            ),
            0
          );
          const lessonFromParameter =
            this.$route.query?.selected_lesson || nextLesson;
          this.$router.replace({ selected_lesson: null });
          this.selectedLesson = product.lessons[lessonFromParameter];
          this.$nextTick(() => {
            const lessonEl = document.getElementById(
              `lesson-${this.selectedLesson.id}`
            );
            const mobileLessonEl = document.getElementById(
              `mobile-lesson-${this.selectedLesson.id}`
            );
            const lessonsListEl = this.$refs.lessonsList;

            if (lessonEl && lessonsListEl) {
              lessonsListEl.scrollTop = lessonEl.offsetTop - 5;
            }
            if (mobileLessonEl) {
              window.mobileLessonEl = mobileLessonEl;
              mobileLessonEl.scrollIntoView();
            }
          });
        }
      },
      immediate: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.lessons-list {
  max-height: 600px;
  height: 600px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: $light-gray;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: white;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: $light-gray;
  }
}

.mobile-lesson-mark {
  position: absolute;
  top: -60px;
}

.review {
  pointer-events: none;
}
</style>
